export const T = {
  en_GB: { preview: "Preview — not saved", advisorsDo: "For advisors" },
  nb_NO: { preview: "Forhåndsvisning — ikke lagret", advisorsDo: "For rådgivere" },
} as const;
